import React from 'react'
import { I18n } from 'react-redux-i18n'
import StarRatingComponent from 'react-star-rating-component'

export default class FeedbackModal extends React.Component {
  state = {
    customerSatisfactionRate: undefined,
    noteType: null,
    note: '',
  }

  componentWillReceiveProps(nextProps) {
    // Update state when modal opens or serviceTxn changes
    if (
      (nextProps.isShow && !this.props.isShow) || // Modal is opening
      (nextProps.isShow && nextProps.serviceTxn !== this.props.serviceTxn) // serviceTxn changed while modal is open
    ) {
      if (nextProps.serviceTxn && nextProps.serviceTxn.serviceInfo) {
        const { customerSatisfactionRate, noteType, note } =
          nextProps.serviceTxn.serviceInfo
        this.setState({
          customerSatisfactionRate,
          noteType,
          note,
        })
      } else {
        // Reset state if no serviceInfo
        this.setState({
          customerSatisfactionRate: undefined,
          noteType: null,
          note: '',
        })
      }
    }
  }

  handleRatingChange = (customerSatisfactionRate) => {
    this.setState((state) => ({
      ...state,
      customerSatisfactionRate,
    }))
  }

  handleRatingClear = () => {
    this.handleRatingChange(undefined)
  }

  handleNoteTypeChange = (noteType) => {
    this.setState({ ...this.state, noteType })
  }

  handleNoteChange = (note) => {
    this.setState({ ...this.state, note })
  }

  handleFeedback = () => {
    const { serviceTxn, onFeedback } = this.props
    const { customerSatisfactionRate, noteType, note } = this.state
    onFeedback(serviceTxn, { customerSatisfactionRate, noteType, note })
  }

  render() {
    const { isShow, onHide, serviceTxn } = this.props
    const label = I18n.t('stationReportScene.feedbackModal')

    if (!isShow) return null

    return (
      <div>
        {/* Backdrop */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50"
          onClick={onHide}
        />

        {/* Modal */}
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-lg w-full">
            {/* Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
              <h2 className="text-xl font-bold text-gray-900 uppercase">
                {label.title}
              </h2>
              <button
                onClick={onHide}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <svg
                  className="w-6 h-6"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="px-6 py-4">
              {renderModalBody(
                serviceTxn,
                label,
                this.state.customerSatisfactionRate,
                this.handleRatingChange,
                this.handleRatingClear,
                this.state.noteType,
                this.handleNoteTypeChange,
                this.state.note,
                this.handleNoteChange,
              )}
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50">
              <button
                onClick={onHide}
                className="px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-100 transition-colors"
              >
                {I18n.t('action.cancel')}
              </button>
              <button
                onClick={this.handleFeedback}
                className="px-6 py-2.5 bg-primary-600 text-white rounded-lg font-medium hover:bg-primary-700 transition-colors shadow-sm"
              >
                {I18n.t('action.save')}
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const renderModalBody = (
  serviceTxn,
  label,
  customerSatisfactionRate,
  onRatingChange,
  onRatingClear,
  noteType,
  onNoteTypeChange,
  note,
  onNoteChange,
) => {
  const handleNoteChange = (e) => onNoteChange(e.target.value)
  if (serviceTxn) {
    return (
      <div className="space-y-4">
        {/* Customer */}
        <div className="grid grid-cols-3 gap-4">
          <div className="text-sm font-medium text-gray-700">
            {label.customer}
          </div>
          <div className="col-span-2 text-base text-gray-900">
            {serviceTxn.reservation.mainPax.fullName}
          </div>
        </div>

        {/* Customer Satisfaction Rate */}
        <div className="grid grid-cols-3 gap-4">
          <div className="text-sm font-medium text-gray-700">
            {label.customerSatisfactionRate}
          </div>
          <div className="col-span-2 flex items-center gap-3">
            <StarRatingComponent
              className="kiosk-star"
              name="customerSatisfactionRate"
              value={customerSatisfactionRate}
              onStarClick={onRatingChange}
              starCount={3}
            />
            <button
              onClick={onRatingClear}
              className="text-red-600 hover:text-red-700 transition-colors"
              title="Clear rating"
            >
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
        </div>

        {/* Note Type */}
        <div className="grid grid-cols-3 gap-4">
          <div className="text-sm font-medium text-gray-700">
            {label.noteType}
          </div>
          <div className="col-span-2 flex gap-2">
            <button
              onClick={() => onNoteTypeChange('comment')}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                noteType === 'comment'
                  ? 'bg-primary-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {label.noteTypeComment}
            </button>
            <button
              onClick={() => onNoteTypeChange('complain')}
              className={`px-4 py-2 rounded-lg font-medium transition-colors ${
                noteType === 'complain'
                  ? 'bg-primary-600 text-white'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {label.noteTypeComplain}
            </button>
          </div>
        </div>

        {/* Note */}
        <div className="mt-4">
          <textarea
            value={note}
            onChange={handleNoteChange}
            type="text"
            name="note"
            rows="8"
            className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 resize-y"
            placeholder="Enter feedback notes..."
          />
        </div>
      </div>
    )
  }
  return null
}
